import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import Unauthorized from "./Unauthorized";

const ModuleProtectedRoute = ({ children, moduleName = "rentals" }) => {
  const { loggedInUser, tenant, isLoading } = useUser();

  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Flex>
    );
  }

  if (!loggedInUser) {
    return <Navigate to="/login" />;
  }

  // tolerate multiple naming conventions and user-level module grants
  const tenantModules =
    (tenant &&
      (Array.isArray(tenant.enabled_modules)
        ? tenant.enabled_modules
        : Array.isArray(tenant.enabledModules)
        ? tenant.enabledModules
        : Array.isArray(tenant.modules)
        ? tenant.modules
        : [])) ||
    [];

  const userModules =
    (loggedInUser &&
      (Array.isArray(loggedInUser.allowed_modules)
        ? loggedInUser.allowed_modules
        : Array.isArray(loggedInUser.allowedModules)
        ? loggedInUser.allowedModules
        : Array.isArray(loggedInUser.modules)
        ? loggedInUser.modules
        : [])) ||
    [];

  const enabled =
    tenantModules.includes(moduleName) ||
    userModules.includes(moduleName) ||
    (loggedInUser &&
      Array.isArray(loggedInUser.roles) &&
      loggedInUser.roles.includes("Admin"));

  if (!enabled) {
    return <Unauthorized />;
  }

  return children;
};

export default ModuleProtectedRoute;
